import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIResult, emptyAPIResult, loadingAPIResult, successAPIResult, errorAPIResult } from "../../lib/redux";
import { Customer } from "../../models";
import { triplePSDatasource } from "../../datasource";

interface CustomersState {
  customers: Customer[];
  selectedCustomer?: Customer;
  getCustomersResult: APIResult<Customer[]>;
  getCustomerResult: APIResult<Customer>;
  toggleFavoriteResult: APIResult<Customer>;
}

const initialState: CustomersState = {
  customers: [],
  selectedCustomer: undefined,
  getCustomersResult: emptyAPIResult(),
  getCustomerResult: emptyAPIResult(),
  toggleFavoriteResult: emptyAPIResult(),
};

export const getCustomers = createAsyncThunk(
  "customers/getCustomers",
  async (params: { search?: string; offset: number; count: number; sort?: string }) =>
    triplePSDatasource.getCustomers(params)
);

export const getCustomer = createAsyncThunk(
  "customers/getCustomer",
  async (id: string) => triplePSDatasource.getCustomer(id)
);

export const toggleCustomerFavorite = createAsyncThunk(
  "customers/toggleFavorite",
  async (params: { id: string; isFavorite: boolean }) =>
    triplePSDatasource.toggleCustomerFavorite(params.id, params.isFavorite)
);

export const customersSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomers.pending, (s) => { s.getCustomersResult = loadingAPIResult(); })
      .addCase(getCustomers.fulfilled, (s, a) => { s.getCustomersResult = successAPIResult(a.payload); s.customers = a.payload; })
      .addCase(getCustomers.rejected, (s, a) => { s.getCustomersResult = errorAPIResult(a.error); })
      .addCase(getCustomer.pending, (s) => { s.getCustomerResult = loadingAPIResult(); s.selectedCustomer = undefined; })
      .addCase(getCustomer.fulfilled, (s, a) => { s.getCustomerResult = successAPIResult(a.payload); s.selectedCustomer = a.payload; })
      .addCase(getCustomer.rejected, (s, a) => { s.getCustomerResult = errorAPIResult(a.error); })
      .addCase(toggleCustomerFavorite.pending, (s) => { s.toggleFavoriteResult = loadingAPIResult(); })
      .addCase(toggleCustomerFavorite.fulfilled, (s, a) => {
        s.toggleFavoriteResult = successAPIResult(a.payload);
        const i = s.customers.findIndex((c) => c.id === a.payload.id);
        if (i !== -1) s.customers[i] = a.payload;
        if (s.selectedCustomer?.id === a.payload.id) s.selectedCustomer = a.payload;
      })
      .addCase(toggleCustomerFavorite.rejected, (s, a) => { s.toggleFavoriteResult = errorAPIResult(a.error); });
  },
});

export default customersSlice.reducer;
